export const tip = {
	title: "Configuración de propina",
};
